

export default (function () {

    var init = function () {
        var bidHasBeenMade = document.getElementById("BidHasBeenMade");
        var auctionId;
        if (bidHasBeenMade) {
            auctionId = bidHasBeenMade.dataset.auctionId;
            
            setTimeout(function () {
                redirectToLotList(auctionId);
            }, 10000);
        }
        var redirectToLotList = function (auctionId) {
            document.location = "/Lots?aid=" + auctionId;
        };

    };
  
    return {
        init: init
    };

})();

